import styled from "styled-components";

export const SchedulerStyled = styled.div`
  ${({ $isFullscreen }) =>
    $isFullscreen &&
    `
    height: 100%;
    display: flex;
    flex-direction: column;
    form {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
    }
    .table_container {
      flex: 1;
      min-height: 0;
      max-height: none !important;
    }
  `}
  .header {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .scheduler_left_col {
      padding-left: 10%;
      .btn_day_week {
        display: flex;
        gap: 10px;
        .btn {
          border: 1px solid ${({ theme }) => theme.COLORS.GRAY_7};
          border-radius: 10px;
          padding: 10px 20px;
          min-width: 40px;
          background: ${({ theme }) => theme.COLORS.WHITE_1};
          text-align: center;
          color: ${({ theme }) => theme.COLORS.BLACK_1};
          font-size: ${({ theme }) => theme.FONT.SIZE.S14};
          font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
          transition: background-color 0.3s;
          cursor: pointer;
          &.active {
            border: 1px solid ${({ theme }) => theme.COLORS.GRAY_8};
            background: ${({ theme }) => theme.COLORS.GRAY_13};
            font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_BOLD};
          }
        }
      }
      .filter_room {
        margin-top: 10px;
        width: 200px;
      }
    }
    .year_right_sec {
      display: flex;
      flex-direction: row;
      column-gap: 30px;
      position: relative;
      z-index: 10;
      .year_selector {
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: ${({ theme }) => theme.FONT.SIZE.S20};
        .btn_next_prev {
          background: none;
          border-radius: 10px;
          border: 1px solid ${({ theme }) => theme.COLORS.GRAY_8};
          padding: 8px 15px 6px 15px;
          font-size: 16px;
          cursor: pointer;
        }
      }

      .date-picker {
        width: 150px;
      }
      .btn_fullscreen {
        display: inline-flex;
        align-items: center;
        column-gap: 6px;
        height: 40px;
        padding: 0 20px;
        border: 1px solid ${({ theme }) => theme.COLORS.GRAY_1};
        border-radius: 50px;
        background: ${({ theme }) => theme.COLORS.WHITE_1};
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
        white-space: nowrap;
        cursor: pointer;
      }
    }
  }

  .table_container {
    position: relative;
    border: 1px solid #e5e5e5;
    border-radius: 12px;
    display: flex;
    align-items: flex-start;
    width: 100%;
    max-width: 100%;
    max-height: calc(100vh - 220px);
    overflow: auto;
    .time_column {
      width: 150px;
      flex-shrink: 0;
      position: sticky;
      left: 0;
      z-index: 3;
      background: ${({ theme }) => theme.COLORS.WHITE_1};
      box-shadow: 2px 0 4px rgba(0, 0, 0, 0.05);
      .time_column_label {
        box-sizing: border-box;
        height: 54px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        padding: 10px;
        text-align: center;
        background: #f5f5f5;
        border-right: 1px solid #e5e5e5;
        border-bottom: 1px solid #e5e5e5;
        position: sticky;
        top: 0;
        z-index: 4;
      }
      .time_row {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 60px;
        padding-left: 10px;
        border-right: 1px solid #e5e5e5;
        border-bottom: 1px solid #e5e5e5;
        background: ${({ theme }) => theme.COLORS.WHITE_1};
        input[type="checkbox"] {
          margin-right: 8px;
        }
        .time_text {
          font-weight: bold;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        &:last-child {
          border-bottom: none;
        }
      }
    }

    .scheduler_table {
      flex: 1;
      display: flex;
      ${({ $filterValue }) =>
        $filterValue === "day" && `min-width: max-content;`}
      flex-direction: column;
      .main_header {
        display: flex;
        flex-direction: row;
        position: sticky;
        top: 0;
        z-index: 2;
        background: #f5f5f5;
        .table_header {
          flex: 1;
          min-width: ${({ $filterValue }) =>
            $filterValue === "day" ? "180px" : "120px"};
          .header_item {
            box-sizing: border-box;
            height: 54px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 6px 15px;
            font-weight: bold;
            text-align: center;
            line-height: 1.2;
            border-right: 1px solid #e5e5e5;
            border-bottom: 1px solid #e5e5e5;
            background-color: #f5f5f5;
          }
          &:last-child .header_item {
            border-right: none;
          }
        }
      }
      .table_body {
        display: flex;
        flex-direction: column;
        position: relative;
        .row {
          display: flex;
          flex-wrap: wrap;
          width: 100%;
          .cell {
            box-sizing: border-box;
            width: 14.28%;
            ${({ $filterValue }) =>
              $filterValue === "day" && `min-width: 180px;`}
            height: 60px;
            overflow: hidden;
          }
          ${({ $filterValue }) =>
            $filterValue === "day" &&
            `
            .cell:last-child > div {
              border-right: none;
            }
            &:last-child .cell > div {
              border-bottom: none;
            }
          `}
          ${({ $filterValue }) =>
            $filterValue === "week" &&
            `
            .cell:nth-child(7n) > div {
              border-right: none;
            }
            .cell:nth-last-child(-n+7) > div {
              border-bottom: none;
            }
          `}
        }
        .bookings_overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          display: flex;
          pointer-events: none;
          .booking_column {
            flex: 1;
            min-width: ${({ $filterValue }) =>
              $filterValue === "day" ? "180px" : "120px"};
            position: relative;
            .booking_card {
              position: absolute;
              left: 0;
              right: 0;
              pointer-events: auto;
              cursor: pointer;
              > div {
                height: 100%;
                box-sizing: border-box;
                border: 1px solid #e5e5e5;
              }
            }
          }
        }
      }
    }
  }
  .status_legend {
    margin-bottom: 14px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    column-gap: 24px;
    row-gap: 10px;
    .status {
      display: flex;
      align-items: center;
      .status-indicator {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        background-color: green;
        border: 1px solid #333;
        margin-right: 8px;
        &.orange {
          background-color: orange;
        }
        &.red {
          background-color: red;
        }
        &.gray {
          background-color: ${({ theme }) => theme.COLORS.GRAY_2};
        }
      }

      .status-text {
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        color: black;
      }
    }
  }
`;
